import React from 'react';
import { Route, Switch } from 'react-router-dom';

import HomePage from '../src/pages/HomePage';
import ProjectList from '../src/pages/ProjectList';
import ProjectPage from '../src/pages/ProjectPage';
import ClientPage from '../src/pages/ClientPage';
import ContactPage from '../src/pages/ContactPage';
import AboutPage from '../src/pages/AboutPage';
import BlogList from '../src/pages/BlogList';
import BlogPage from '../src/pages/BlogPage';


export default ({ loadFinish, location, wording }) => {
  return (
    <Switch key={location.key} location={location}>
      {loadFinish && <Route exact path={`/`} render={() => <HomePage wording={wording['home']} />} />}
      {wording['project'] && <Route exact path={`/project/`} render={() => <ProjectList wording={wording['project']} />} />}
      {wording['project'] && <Route exact path={`/project/:slug`} render={() => <ProjectPage wording={wording['project']} />} />}
      {wording['client'] && <Route exact path={`/client`} render={() => <ClientPage wording={wording['client']} />} />}
      {wording['contact'] && <Route exact path={`/contact`} render={() => <ContactPage wording={wording['contact']} common={wording['common']} />} />}
      {wording['about'] && <Route exact path={`/about`} render={() => <AboutPage wording={wording['about']} common={wording['common']} />} />}
      {wording['blog'] && <Route exact path={`/blog`} render={() => <BlogList wording={wording['blog']} common={wording['common']} />} />}
      {wording['blog'] && <Route exact path={`/blog/:slug`} render={() => <BlogPage wording={wording['blog']} />} />}
    </Switch>
  )
}